import { z } from 'zod'

export default z.object({
  __typename: z.literal('Order').default('Order'),
  id: z.number(),
  status: z.string(),
  tech_user_id: z.string().nullable(),
})
